/** Amir's booking page: onboarding, billing and cancellation help all land here. */
export const AMIR_CALL_URL = "https://calendar.notion.so/meet/amirmot/4a1bs4yr2"
